export default [
    {
        county: 'Los Angeles County',
        countyPath: 'los-angeles-county-ca/'
    },
    {
        county: 'San Diego County',
        countyPath: 'san-diego-county-ca/'
    },
    {
        county: 'Orange County',
        countyPath: 'orange-county-ca/'
    },
    {
        county: 'Riverside County',
        countyPath: 'riverside-county-ca/'
    },
    {
        county: 'San Bernardino County',
        countyPath: 'san-bernardino-county-ca/'
    },
    {
        county: 'Santa Clara County',
        countyPath: 'santa-clara-county-ca/'
    },
    {
        county: 'Sacramento County',
        countyPath: 'sacramento-county-ca/'
    },
    {
        county: 'Contra Costa County',
        countyPath: 'contra-costa-county-ca/'
    },
    {
        county: 'Fresno County',
        countyPath: 'fresno-county-ca/'
    },
    {
        county: 'Kern County',
        countyPath: 'kern-county-ca/'
    },
    {
        county: 'San Francisco County',
        countyPath: 'san-francisco-county-ca/'
    },
    {
        county: 'Ventura County',
        countyPath: 'ventura-county-ca/'
    },
    {
        county: 'San Mateo County',
        countyPath: 'san-mateo-county-ca/'
    },
    {
        county: 'San Joaquin County',
        countyPath: 'san-joaquin-county-ca/'
    }
];
